import { go, html, range, reject, strMap } from 'fxjs/es';
import { UtilS } from '../../../Util/S/Function/module/UtilS.js';

export const makePagination = ({
  total_page,
  current_page,
  limit = 10,
  page_length = 5,
  hide_edges = false,
}) => {
  total_page = Math.max(total_page, 1);
  const pages = go(
    Math.floor((current_page - 1) / page_length) * page_length,
    (page_first) => range(page_first + 1, page_first + 1 + page_length),
    reject((page) => page > total_page),
  );

  const is_first = current_page === 1;
  const is_last = current_page === total_page;
  const current_offset = (current_page - 1) * limit;

  return html` <div
    data-page="${current_page}"
    data-offset="${current_offset}"
    data-limit="${limit}"
    data-total="${total_page}"
    data-length="${page_length}"
    class="maple-labs-pagination"
  >
    <div class="maple-labs-pagination__buttons">
      ${UtilS.htmlIf(
        !hide_edges,
        html`<span
          class="maple-labs-pagination__item maple-labs-pagination__first"
          data-page="1"
          data-offset="0"
          data-limit="${limit}"
          data-total="${total_page}"
          data-length="${page_length}"
          disabled="${is_first}"
        >
          First
        </span>`,
      )}
      <span
        class="maple-labs-pagination__item maple-labs-pagination__prev"
        data-page="${Math.max(current_page - 1, 1)}"
        data-offset="${Math.max((current_page - 1 - 1) * limit, 0)}"
        data-limit="${limit}"
        data-total="${total_page}"
        data-length="${page_length}"
        disabled="${is_first}"
      >
        Prev
      </span>
    </div>
    <div class="maple-labs-pagination__pages">
      ${go(
        pages,
        strMap((page) => {
          const offset = (page - 1) * limit;
          return html`<span
            data-page="${page}"
            data-offset="${offset}"
            data-limit="${limit}"
            data-total="${total_page}"
            data-length="${page_length}"
            data-active="${page == current_page}"
            class="maple-labs-pagination__item maple-labs-pagination__page"
          >
            ${page}
          </span>`;
        }),
      )}
    </div>
    <div class="maple-labs-pagination__buttons">
      <span
        class="maple-labs-pagination__item maple-labs-pagination__next"
        data-page="${Math.min(current_page + 1, total_page)}"
        data-offset="${Math.min(current_page * limit, (total_page - 1) * limit)}"
        data-limit="${limit}"
        data-total="${total_page}"
        data-length="${page_length}"
        disabled="${is_last}"
      >
        Next
      </span>
      ${UtilS.htmlIf(
        !hide_edges,
        html`<span
          class="maple-labs-pagination__item maple-labs-pagination__last"
          data-page="${total_page}"
          data-offset="${(total_page - 1) * limit}"
          data-limit="${limit}"
          data-total="${total_page}"
          data-length="${page_length}"
          disabled="${is_last}"
        >
          Last
        </span>`,
      )}
    </div>
  </div>`;
};
